/**
 * Human-readable reach for a business tier, DERIVED from scope_type / scope_value /
 * boundary_level — never hardcoded distances. Shared by /pricing and /business/register so
 * both describe what a tier buys identically.
 *
 *   nearest              → shown only on the single nearest masjid (the free floor)
 *   radius + scope_value → "Within N km" (N comes from the DB, e.g. 1 km, 5 km)
 *   boundary + city      → across the business's city
 *   boundary + state     → across the state
 *   boundary + national  → nationwide
 */
export function businessScopeLabel(t: { scopeType?: string | null; scopeValue?: number | null; boundaryLevel?: string | null }): string {
  switch (t.scopeType) {
    case 'nearest':
      return 'Shown on your nearest masjid'
    case 'radius':
      return t.scopeValue != null ? `Within ${t.scopeValue} km` : 'Within a set radius'
    case 'boundary':
      switch (t.boundaryLevel) {
        case 'city': return 'Across your city'
        case 'state': return 'Across your state'
        case 'national': return 'Nationwide'
        default: return ''
      }
    default:
      return ''
  }
}
